import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getHoldingList as getHoldingListApi,
	getHolding as getHoldingApi,
	addNewHolding as addNewHoldingApi,
	updateHolding as updateHoldingApi,
	deleteHolding as deleteHoldingApi,
} from '../../helpers/establishment/backend_helper';

export const getHoldingList = createAsyncThunk('holdings/getHoldingList', async () => {
	try {
		const response = getHoldingListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getHolding = createAsyncThunk('holdings/getHolding', async holding_id => {
	try {
		const response = getHoldingApi(holding_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewHolding = createAsyncThunk('holdings/addNewHolding', async holding => {
	try {
		const response = addNewHoldingApi(holding);
		toast.success('Holding agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar holding.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateHolding = createAsyncThunk('holdings/updateHolding', async (holding) => {
		try {
			const response = updateHoldingApi(holding);
			toast.success('Holding actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar holding.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteHolding = createAsyncThunk('holdings/deleteHolding', async holding => {
	try {
		const response = await deleteHoldingApi(holding);
		toast.success('Holding eliminado exitosamente.', { autoClose: 3000 });
		return { holding, ...response };
	} catch (error) {
		toast.error('Error al eliminar holding.', { autoClose: 3000 });
		throw new Error(error);
	}
});
